import React, { useCallback } from 'react';

import { ReportingContext } from '@ubisend/pulse-errors';

const ReportingProvider = ({ children }) => {
  const report = useCallback(() => { }, []);
  const setContext = useCallback(() => { }, []);
  const setTag = useCallback(() => { }, []);
  const setUser = useCallback(() => { }, []);
  const clearScope = useCallback(() => { }, []);

  const context = {
    report,
    setContext,
    setTag,
    setUser,
    clearScope
  };

  return (
    <ReportingContext.Provider value={context}>
      {children}
    </ReportingContext.Provider>
  );
};

export default ReportingProvider;
